import React from "react";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import { RefreshIcon } from "@heroicons/react/outline";
import { useApi } from "../../core/contexts/ApiProvider";
import { useFlash } from "../../core/contexts/FlashProvider";
import { useUser } from "../../core/contexts/UserProvider";

import Loading from "../../components/LoadingError/Loading";
// form validation rules
const SignupSchema = Yup.object().shape({
  firstName: Yup.string().required("Champs requis"),
  lastName: Yup.string().required("Champs requis"),
  email: Yup.string()
    .email("Adresse e-mail invalide")
    .required("Champs requis")
});

export default function EditProfilePage() {
  const { user } = useUser();

  const api = useApi();
  const flash = useFlash();
  const navigate = useNavigate();
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      profilePicture: user?.profilePicture,
      firstName: user?.firstName,
      lastName: user?.lastName,
      email: user?.email,
    },
    validationSchema: SignupSchema,
    onSubmit: async (values) => {
      const response = await api.put("/api/auth/me", values);
      if (response.success) {
        flash(`Modification reussi`, "success");
        navigate(`/profile`);
      } else {
        flash(`${response.error.message}`, "danger");
      }
    },
  });

  return (
    <div className="relative bg-white px-4">
      <div className="max-w-2xl mx-auto">
        <div className="flex space-x-10">
          <div className="flex-[3]">
            <div className="py-4 px-4 flex items-center justify-between sticky top-0 z-10 bg-white">
              <h1 className="text-3xl font-extrabold tracking-tight text-gray-900 py-6">
                Modifier mon profile
              </h1>
            </div>

            {!user ? (
              <div className="mb-5">
                <Loading />
              </div>
            ) : (
              <div className="px-4">
                <form onSubmit={formik.handleSubmit}>
                  <div className="my-2">
                    <label>Nom</label>
                    <input
                      className="input"
                      type="text"
                      name="firstName"
                      value={formik.values.firstName}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.firstName && formik.errors.firstName ? (
                      <span className="text-red-500 text-sm">
                        {formik.errors.firstName}
                      </span>
                    ) : null}
                  </div>
                  <div className="my-2">
                    <label>Prenoms</label>
                    <input
                      className="input"
                      type="text"
                      name="lastName"
                      value={formik.values.lastName}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.lastName && formik.errors.lastName ? (
                      <span className="text-red-500 text-sm">
                        {formik.errors.lastName}
                      </span>
                    ) : null}
                  </div>
                  <div className="my-2">
                    <label>Email adresse</label>
                    <input
                      className="input"
                      type="email"
                      name="email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.email && formik.errors.email ? (
                      <span className="text-red-500 text-sm">
                        {formik.errors.email}
                      </span>
                    ) : null}
                  </div>
                  
                  <div className="my-2">
                    <button className="btn" type="submit">
                      {formik.isSubmitting ? (
                        <RefreshIcon
                          className="animate-spin h-5 w-5 mr-3 ..."
                          viewBox="0 0 24 24"
                        />
                      ) : (
                        "Enregistrer"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
